/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     *{font-family:Open Sans;font-size:14px;color:#8e8fa6;margin-bottom:0;margin-top:-12px}"];
export { styles as styles };
